import { SkewLessIcon } from './SkewLessIcon';

/**
 * author: Michael Irigoyen
 * id 43E5E22F-AEEB-406D-BEF3-898BE3C91FC1
 * name skew-less
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skew-less.svg
 * tags
 * - Math 
 */
export const SkewDecreaseIcon = SkewLessIcon;
export default SkewDecreaseIcon